"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpDataTableRowRowHeader = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const row_header_html_1 = __importDefault(require("./row-header.html"));
const column_1 = require("./column");
let ItpDataTableRowRowHeader = class ItpDataTableRowRowHeader extends vue_1.default {
    col;
    row;
    rowExpander;
    displayRowDetails;
    get expanderIcon() {
        return this.displayRowDetails ? 'fa-angle-down' : 'fa-angle-right';
    }
    get rowspan() {
        return this.displayRowDetails ? 2 : 1;
    }
    toggleRowDetails() {
        this.$emit('toggle', !this.displayRowDetails);
    }
};
exports.ItpDataTableRowRowHeader = ItpDataTableRowRowHeader;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", column_1.ColumnDefinition)
], ItpDataTableRowRowHeader.prototype, "col", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], ItpDataTableRowRowHeader.prototype, "row", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTableRowRowHeader.prototype, "rowExpander", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTableRowRowHeader.prototype, "displayRowDetails", void 0);
exports.ItpDataTableRowRowHeader = ItpDataTableRowRowHeader = __decorate([
    (0, vue_property_decorator_1.Component)({ template: row_header_html_1.default })
], ItpDataTableRowRowHeader);
//# sourceMappingURL=row-header.js.map